module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/february/mainvisual-title_39289d1ac58d0be392a274af6e8b7973.png";